module.exports = __webpack_public_path__ + "img/apple.faae2a12.png";